import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getHiringStages, fetchQualifyingQuestions } from '../Redux/ActionCreators/jobsAction';
import { Dialog } from '@mui/material';
import "react-datetime/css/react-datetime.css";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from 'react-router-dom';


export default function ApplyStageModal(props) {
    const [stageId, setStageId] = useState('');
    const [stageName, setStageName] = useState("");
    const [videoDate, setVideoDate] = useState(new Date());
    const [timezone, setTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);
    const [loadingStages, setLoadingStages] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const { hiringStages, qualifyingQuestions  } = useSelector(state => state.jobs)
    const latestJob = useSelector((state) => state.jobs.latestJob);
    const { isOpen, setIsOpen, selectAssignedStage, jobId, loading, assignProgress, preselectStage, stagePermissions = {}, } = props

    useEffect(() => {
        const fetchStages = async () => {
            setLoadingStages(true);
            await dispatch(fetchQualifyingQuestions(jobId));
            await dispatch(getHiringStages(jobId));
            setLoadingStages(false);
        };
        fetchStages();
    }, [dispatch, jobId]);

    const stageOrder = ["Pre Screening", "Voice Call", "Assessment", "Video Call"];

    const sortedStages = Array.isArray(hiringStages) ? hiringStages.slice().sort((a, b) => stageOrder.indexOf(a?.hiring_stage?.name) - stageOrder.indexOf(b?.hiring_stage?.name)): [];

    useEffect(() => {
        if (!sortedStages || !preselectStage) return;

        const selected = sortedStages.find(
            (el) => el?.hiring_stage?.name === preselectStage
        );

        if (selected) {
            setStageId(selected.id);
            setStageName(preselectStage);
        }
    }, [sortedStages, preselectStage]);

    const selectedStageObj = stageId && sortedStages.length ? sortedStages.find((el) => el.id === stageId): null;
    const masterStageId = selectedStageObj?.hiring_stage_id;
    const currentStagePermission = masterStageId && stagePermissions ? stagePermissions[masterStageId]: null;
    const canAssignStage = currentStagePermission?.canAssign !== false;
    const restrictionMessage = currentStagePermission?.message;

    return (
        <div>
            {loading && <Dialog
                className='schedule-loader'
                open={loading}
                onClose={() => { }}
                PaperProps={{
                    sx: {
                        boxShadow: 'none'
                    }
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{color:'#f75891'}}
            >
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </Dialog>}
            <Modal
                show={isOpen}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                dialogClassName={"assigned-stage-modal"}
            >
                <div class="modal-header">
                    <div></div>
                    <h5 class="modal-title">Assign Stage</h5>
                    <div className="sticky-close cursor-pointer" onClick={() => setIsOpen(false)}>
                        <img src="/images/close-icon.svg" width='24px' height='24px' alt='' />
                    </div>
                </div>
                <Modal.Body>
                    <div className='modal-body-main'>
                        {assignProgress?.total > 0 ? (
                        <div style={{ fontWeight: 600, marginBottom: '10px' }}>
                            Assigning stage... {assignProgress.current} of {assignProgress.total}
                        </div>
                        ) : (
                            <>
                                <div>
                                    {loadingStages ? (
                                        <div
                                            className="loading-overlay"
                                            style={{
                                                position: "relative",
                                                marginTop: 16,
                                                alignItems: "start",
                                                height: '32px'
                                            }}
                                        >
                                            <div className="spinner-border" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <label>Select Stage</label>
                                            <select
                                                className="form-control"
                                                value={stageId} 
                                                onChange={(e) => {
                                                const selectedStage = sortedStages.find(
                                                    (el) => el?.id === e.target.value
                                                );
                                                setStageId(e.target.value);
                                                setStageName(selectedStage?.hiring_stage?.name);
                                                }}
                                            >
                                                <option hidden>Select Assigned Stage</option>
                                                {sortedStages?.map((el) => (
                                                <option key={el?.id} value={el?.id}>
                                                    {el.hiring_stage?.name}
                                                </option>
                                                ))}
                                            </select>
                                            <div className='mt-4' style={{ width: '205px' }}>
                                                <label>Due Date</label>
                                                <DatePicker
                                                    className="form-control"
                                                    selected={videoDate}
                                                    onChange={(date) => setVideoDate(date)}
                                                    minDate={new Date()}
                                                    dateFormat="yyyy-MM-dd"
                                                />
                                            </div>
                                            {!canAssignStage && restrictionMessage && (
                                                <div style={{ marginTop: "12px", color: "#FF5733", fontSize: "14px", fontWeight: 500, textAlign: 'center', width:'205px'}}>
                                                    {restrictionMessage}
                                                </div>
                                            )}
                                            {/* Pre Screening validation */}
                                            {stageName === "Pre Screening" && qualifyingQuestions?.length === 0 && (
                                                <div
                                                style={{
                                                    marginTop: "12px",
                                                    color: "#6b7280",
                                                    fontSize: "14px",
                                                    fontWeight: 500,
                                                    textAlign: 'center'
                                                }}
                                                >
                                                There are no Pre-Screening <br />questions. Please go to<br />
                                                Job Settings and create them.
                                                </div>
                                            )}

                                            {/* Assessment validation */}
                                            {stageName === "Assessment" && (!latestJob?.assessment_id || latestJob?.assessment_id === null) && (
                                                <div
                                                    style={{
                                                        marginTop: "12px",
                                                        color: "#6b7280",
                                                        fontSize: "14px",
                                                        fontWeight: 500,
                                                        textAlign: 'center'
                                                    }}
                                                >
                                                    Assessment was not added.<br />
                                                    Please go to My Assessments and add one.
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                    {assignProgress?.total === 0 && (
                        <div className='apply-btn d-flex justify-content-center'>
                            {stageName === "Pre Screening" && qualifyingQuestions?.length === 0 ? (
                                <button onClick={() => navigate(`/jobs/${jobId}/settings`)}>
                                Job Settings
                                </button>
                            ) : stageName === "Assessment" && (!latestJob?.assessment_id || latestJob?.assessment_id === null) ? (
                                <button onClick={() => navigate(`/assessments`)}>
                                    My Assessments
                                </button>
                            ) : (
                                <>
                                {canAssignStage && (
                                    <button disabled={loading || !(videoDate && stageId)} onClick={() => selectAssignedStage(stageId, videoDate, timezone)}>
                                        Apply
                                    </button>
                                )}
                                </>
                            )}
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </div>
    )
}
